import axios from 'axios';
import {ErrorCode} from '@/constant/error-code';
import "@/constant/initEnv";
import { ElMessage } from 'element-plus'



axios.defaults.baseUrl = global.baseUrl;
axios.defaults.timeout = 30000;
axios.defaults.headers = {
    'Content-Type': 'application/json;charset=UTF-8',
}

//http request 拦截器
axios.interceptors.request.use(
    config => {
        config.headers['token'] = "";
        return config;
    },
    error =>{
        return Promise.reject(error);
    }
);

//http response 拦截器
axios.interceptors.response.use(
    response => {
        // const { toastMsg, toastSuccMsg, notToast, allData} = response.config;
        if(response.status == 200){
            if(response.data.success || response.data.errorCode == '200' || response.data.error_code == 0){
                if(response.data.error_msg){
                    handleSuccess(response.data.error_msg)
                }else{
                    return response.data
                }
                
            }else{
                handleError(response.data.error_code,response.data.error_msg)
            }
            // if(allData){
            //     //返回所有response
            //     if(!response.data.success){
            //         !notToast && handleError(response.data.errorCode,toastMsg || response.data.errorMsg || response.data.message ||response.data.error_msg)
            //     }
            //     if(toastSuccMsg) handleSuccess(toastSuccMsg);
            //     if(response.config.response){
            //         return response;
            //     }else{
            //         return response.data
            //     }
            // }else if(response.data.success || response.data.error_code == 0){
            //     //接口成功，只返回data
            //     if(toastSuccMsg) handleSuccess(toastSuccMsg);
            //     return response.data.data;
            // }else{
            //    !notToast && handleError(response.data.error_code,toastMsg || response.data.message||response.data.error_msg||response.data.errorMsg)
            //    return null;
            // }
        }else{
            handleError('','')
        }
    },
    async error => {
        
        // const { toastMsg, notToast } = error.config;
        if(error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1){
            handleError('timeout');
             return Promise.reject(error);
        }else{
            if(process.env.STAGE === 'dev'){
                handleError('',error.message);
            }
            return Promise.reject(error);
        }
    }
);

const HTTP= {
    /**
   * 封装get/delete/post/patch/put方法
   * @param url
   * @param data
   * @param config 合并默认config
   * @returns {Promise}
   * 使用this.$http.(get/delete/post/path/put)('/food', {"name" : 1}, {timeout: 1000}).then(res=>{}).catch(err=>{})
   */
    get: (url, data = {}, config = {}) => axios['get'](url,{...{params: data},...config}),
    put: (url, data = {}, config = {}) => axios['put'](url, data, config),
    post: (url, data = {}, config = {}) => axios['post'](url, data, config),
    patch: (url ,data = {}, config = {}) => axios['patch'](url, data, config),
    delete: (url, data = {}, config = {}) => axios['delete'](url, {...{params: data},...config})
}

function handleError(code, msg){
    if(ErrorCode[code]){
        ElMessage({
            message: msg || ErrorCode[code],
            type: 'error',
            duration: 3*1000
        })
    }else{
        ElMessage({
            message: msg || '出错啦.....请刷新页面或重试',
            type: 'error',
            duration: 3*1000
        })
    }
}

function handleSuccess(msg){
    ElMessage({
        message: msg,
        type: 'success',
        duration: 3*1000
    })
}

export default HTTP;